import script from "./ReportVisitClientFormDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportVisitClientFormDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ReportVisitClientFormDrawer.vue?vue&type=style&index=0&id=0aab3d46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aab3d46"]])

export default __exports__